// Calendar-date display helpers (byte-for-byte the same rules as
// mobile/lib/dates.ts). Ledger dates are plain YYYY-MM-DD strings — no
// time, no zone — so these format them without going through a Date,
// and no timezone can shift a day.

const SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const LONG = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** Local wall-clock today as YYYY-MM-DD. */
export function todayISO(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** "2027-01-09" → "Jan 9" */
export function shortDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return `${SHORT[Number(iso.slice(5, 7)) - 1] ?? '?'} ${Number(iso.slice(8, 10))}`;
}

/** "2027-01-09" → "Jan 9, 2027" */
export function mediumDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return `${shortDate(iso)}, ${iso.slice(0, 4)}`;
}

/** "2027-01" or "2027-01-09" → "January 2027" */
export function monthYear(iso: string): string {
  return `${LONG[Number(iso.slice(5, 7)) - 1] ?? '?'} ${iso.slice(0, 4)}`;
}
